import { render, staticRenderFns } from "./UserCompanyTable.vue?vue&type=template&id=3117c2b6&scoped=true&"
import script from "./UserCompanyTable.vue?vue&type=script&lang=js&"
export * from "./UserCompanyTable.vue?vue&type=script&lang=js&"
import style0 from "./UserCompanyTable.vue?vue&type=style&index=0&id=3117c2b6&lang=scss&scoped=true&"
import style1 from "./UserCompanyTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3117c2b6",
  null
  
)

export default component.exports